export default __webpack_public_path__ + "static/media/forensic-audit.39b20c14.svg";